import React, { useEffect } from "react";
import Lenis from "lenis";
import UrgencyBanner from "@/components/UrgencyBanner";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import LegacyBar from "@/components/LegacyBar";
import EditorialMarquee from "@/components/EditorialMarquee";
import ProductGrid from "@/components/ProductGrid";
import SNCollection from "@/components/SNCollection";
import ConsortiumRange from "@/components/ConsortiumRange";
import HowItWorks from "@/components/HowItWorks";
import Services from "@/components/Services";
import Relationships from "@/components/Relationships";
import WhyTrustUs from "@/components/WhyTrustUs";
import BrandStory from "@/components/BrandStory";
import Testimonials from "@/components/Testimonials";
import Blog from "@/components/Blog";
import CtaBand from "@/components/CtaBand";
import Ornament from "@/components/Ornament";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

const scrollToId = (id) => {
  if (window.__lenis) window.__lenis.scrollTo(id, { offset: -80 });
  else {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      autoRaf: true,
    });
    window.__lenis = lenis;
    return () => {
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <>
      <UrgencyBanner />
      <Navigation />
      <main>
        <Hero onShopNow={() => scrollToId("#shop")} />
        <LegacyBar />
        <EditorialMarquee />
        <ProductGrid />
        <SNCollection />
        <ConsortiumRange />
        <HowItWorks />
        <Services />
        <Relationships />
        <WhyTrustUs />
        <BrandStory />
        <Testimonials />
        <Blog />
        <CtaBand />
        <Ornament />
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
}
